<template slot-scope="tour">
  <v-tour
    name="pageTour"
    :steps="steps[$route.path]"
  >
    <tour-guide-module
      slot-scope="tour"
      :tour="tour"
      :steps="steps"
      :set-as-visualized="stopTourGuide"
    />
  </v-tour>
</template>

<script>
import TourGuideModule from './TourGuideModule'
import strings from '@/strings'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TourGuide',
  components: {
    'tour-guide-module': TourGuideModule
  },
  data: () => ({
    steps: strings
  }),
  methods: {
    ...mapActions(['getUserProfile', 'updateTutorialsList']),
    startTourGuide() {
      this.$tours['pageTour'].start()
    },
    stopTourGuide() {
      this.$tours['pageTour'].stop()
      this.updateTutorialsList({ tutorial: 'tourOfCurrentPage', action: false })
    }
  },
  computed: {
    ...mapGetters(['profile']),
    ...mapGetters(['isComunicationSidebarVisible']),
    ...mapGetters({ list: 'tutorialsList' })
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.$tours['pageTour'].stop()
      }
    },
    isComunicationSidebarVisible: function (newVal) {
      if (!newVal) {
        this.$tours['pageTour'].stop()
      }
    },
    list: {
      handler: function (newList) {
        if (newList.tourOfCurrentPage) this.startTourGuide()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.v-step {
  z-index: 999;
}
</style>
